import { render, staticRenderFns } from "./ClComponent.vue?vue&type=template&id=f0bb9e6e&scoped=true&"
import script from "./ClComponent.vue?vue&type=script&lang=ts&"
export * from "./ClComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ClComponent.vue?vue&type=style&index=0&id=f0bb9e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bb9e6e",
  null
  
)

export default component.exports